import type { CountrySection } from "../../api/types";

/** Fiche pays : fonctions pures de la vue, testées par countrySheet.test.ts. */

/** Bouton « Rédiger la fiche pays » (vue, état vide), désigné par le menu d'export du dossier quand la fiche manque. */
export const COUNTRY_WRITE_TARGET = "country-write";

/** Rubriques de texte que l'IA n'a pas encore rédigées (ou dont la rédaction ne suit plus le dossier : « À
 *  régénérer »), ni modifiées à la main : « Rédiger la fiche pays » les lui confie (aucune : il les rédige toutes de
 *  nouveau, modifications gardées). */
export function sectionsToWrite(
  sections: readonly (Pick<CountrySection, "id" | "ai" | "edited" | "status"> & { stale?: boolean })[],
): string[] {
  return sections.filter((s) => s.ai && !s.edited && (s.status !== "ok" || s.stale)).map((s) => s.id);
}

/** Fiche composée : au moins une rubrique a un texte (exportable, comme la mise en ambiance rédigée). */
export function sheetWritten(sheet: { sections?: readonly Pick<CountrySection, "text">[] } | null | undefined): boolean {
  return Boolean(sheet?.sections?.some((s) => s.text.trim()));
}
